import axios from 'axios';
import { api } from '../../utils/api';
import { getAuthToken } from '../../utils/utils';

const showAllPosts = async ({ userid }) => {
  const config = {
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
    },
  };
  try {
    const res = await axios.post(
      `${api}/Show_All_Post`,
      {
        userid,
      },
      config
    );
    return res;
  } catch (err) {
    return err;
  }
};

function endpoint(type) {
  switch (type) {
    case 'Instant Post':
      return 'Post_To_All_SocialMedia_Immediatly';
    case 'Schedule Post':
      return 'Post_To_All_SocialMedia_Scheduling';
  }
}

const createPost = async ({ payload }) => {
  const postType = payload.postType;
  delete payload.postType;
  const config = {
    headers: {
      Authorization: `Bearer ${getAuthToken()}`,
      'Content-Type': 'multipart/form-data',
      Accept: 'application/json',
    },
  };
  try {
    const res = await axios.post(
      `${api}/${endpoint(postType)}`,
      payload,
      config
    );
    return res;
  } catch (err) {
    return err;
  }
};

const postService = {
  showAllPosts,
  createPost,
};

export default postService;
